import api from './index';

/**
 * Obtener info completa de referidos del usuario conectado:
 * { code, referredBy, totalReferred, totalEarnings, pendingEarnings, referredList, config }
 */
export async function getMyReferralInfo() {
  const response = await api.get('/referrals/my-info');
  return response.data.data;
}

/**
 * Registrar al usuario actual como referido de un codigo de 6 caracteres
 */
export async function registerWithCode(code) {
  const response = await api.post('/referrals/register', { code });
  return response.data;
}
